<template>
    <div>
        <div class="tw-grid tw-auto-rows-max tw-gap-16 tw-grid-cols-1 tw-mt-8">
            <div class="tw-col-span-2">
                <l-content-box>
                    <template
                        v-if="survey && Array.isArray(survey.periods) && survey.periods.length"
                    >
                        <l-survey-participation-rate-chart :survey-periods="surveyData" />

                        <l-survey-participation-rate-details
                            v-if="canAccessParticipantDetails"
                            class="tw-mt-8"
                            :survey-id="survey._id"
                            :survey-periods="survey.periods"
                            :is-anonymous-survey="isAnonymousSurvey"
                        />
                    </template>

                    <div v-else class="tw-text-center">
                        {{ $t("surveys.period.noPeriodStarted") }}
                    </div>
                </l-content-box>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { chronologically } from "@/utils/sort-object";

import LSurveyParticipationRateChart from "@/components/LSurveyParticipationRateChart";
import LContentBox from "@/components/LContentBox";

export default {
    components: {
        LSurveyParticipationRateChart,
        LSurveyParticipationRateDetails: () =>
            import("@/components/LSurveyParticipationRateDetails"),
        LContentBox,
    },
    props: {
        survey: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
        }),
        isAnonymousSurvey() {
            return this.survey?.settings?.notAnonymous !== true;
        },
        canAccessParticipantDetails() {
            return this.survey?.isOwner || this.rights.S_ACCESS_ALL;
        },
        surveyData() {
            return Array.isArray(this.survey?.periods)
                ? this.survey.periods
                      .filter(period => !!period.stats?.participationRate?.lastUpdated)
                      .map(period => ({
                          _id: period._id,
                          startDate: period.start,
                          endDate: period.end,
                          totalAmount: period.stats?.participationRate?.result?.totalAmount ?? 0,
                          doneAmount: period.stats?.participationRate?.result?.doneAmount ?? 0,
                          notDoneAmount:
                              period.stats?.participationRate?.result?.notDoneAmount ?? 0,
                          participationInPercent:
                              period.stats?.participationRate?.result?.participationInPercent ?? 0,
                      }))
                      .sort(chronologically("startDate"))
                : [];
        },
    },
};
</script>
